// @ts-nocheck
import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { Table } from '../../../components/ant/table/Table';
import Header from '../../../components/layout/Header';
import { Section } from '../../../components/layout';
import Filter from './components/Filter';
import { fuelGroups, fuelGroupEnum, vehicleTypes } from '../../../lib/enum';
const initialParams = {
  startDate: moment.utc().startOf('month').toISOString(),
  endDate: moment.utc().endOf('month').toISOString()
};
/**
 * Сравнительный отчет об оказании автотранспортных услуг
 */
export class ComparingTransportServicesList extends React.Component {
  state = {
    params: initialParams,
    loading: false
  };
  handleChangeFilter = (key, value) => {
    this.setState(prevState => ({
      params: {
        ...prevState.params,
        [key]: value
      }
    }));
  };
  applyParams = async () => {};
  cleanParams = () => this.setState({
    params: initialParams
  });
  handleExport = async () => {};
  mock = [{
    orgUnitName: 'Главный',
    date: '20.12.2018',
    type: 'car',
    brandName: 'Nissan',
    licensePlate: 'Т865ХМ 716',
    kilometrage: 166,
    kilometrageDeviation: 0.15,
    fuel: 23,
    fuelDeviation: 0.25,
    fuelGroup: fuelGroupEnum.petrol,
    totalWorkTime: 12
  }, {
    orgUnitName: 'Главный',
    date: '20.12.2018',
    type: 'car',
    brandName: 'Лада',
    licensePlate: 'К325ЛМ 16',
    kilometrage: 25500,
    kilometrageDeviation: 0.1,
    fuel: 56,
    fuelDeviation: 0.15,
    fuelGroup: fuelGroupEnum.petrol,
    totalWorkTime: 10
  }, {
    orgUnitName: 'Главный',
    date: '20.12.2018',
    type: 'car',
    brandName: 'Reno',
    licensePlate: 'М124КВ 116',
    kilometrage: 673133,
    kilometrageDeviation: 0.56,
    fuel: 30,
    fuelDeviation: 0.25,
    fuelGroup: fuelGroupEnum.petrol,
    totalWorkTime: 56
  }];
  columns = [{
    title: 'Филиал',
    dataIndex: 'orgUnitName'
  }, {
    title: 'Дата формирования',
    dataIndex: 'date'
  }, {
    title: 'Тип ТС',
    dataIndex: 'type',
    render: type => vehicleTypes[type]
  }, {
    title: 'Марка ТС',
    dataIndex: 'brandName'
  }, {
    title: 'Гос. номер',
    dataIndex: 'licensePlate'
  }, {
    title: 'Пробег',
    dataIndex: 'kilometrage',
    render: value => `${value} км.`
  }, {
    title: '% отклонения по пробегу',
    dataIndex: 'kilometrageDeviation',
    render: value => `${value} %`
  }, {
    title: 'ГСМ',
    dataIndex: 'fuel',
    render: value => `${value} л.`
  }, {
    title: '% отклонения по ГСМ',
    dataIndex: 'fuelDeviation',
    render: value => `${value} %`
  }, {
    title: 'Вид топлива',
    dataIndex: 'fuelGroup',
    render: value => fuelGroups[value]
  }, {
    title: 'Кол-во мащ/часов',
    dataIndex: 'totalWorkTime'
  }];
  render() {
    const {
      loading
    } = this.state;
    return <>
        <Header left={<h1>Сравнительный отчет об оказании автотранспортных услуг</h1>} />
        <Section>
          <Filter params={this.state.params} onChangeFilter={this.handleChangeFilter} applyParams={this.applyParams} cleanParams={this.cleanParams} onExport={this.handleExport} />
          <Table loading={loading} pagination={false} dataSource={this.mock} columns={this.columns} />
        </Section>
      </>;
  }
}
export default connect(state => ({}), {})(ComparingTransportServicesList);
